
//warning! because it is entry point used in backward compatible files
//it should be totally independent on external js files
//only vendor files and files from this dir can be imported
import './patches-polyfills';
import './side-effects';

export * from './common';
export * from './common-binary';
export * from './commons-ui2';
export * from './constants';
export * from './simpleFilter';
